import { InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import { styles } from '../../styles';

const danger = css`
  ${styles.borderColor.danger};
  :hover,
  :focus,
  :active {
    ${styles.borderColor.danger};
  }
`;
const success = css`
  ${styles.borderColor.success};
  :hover,
  :focus,
  :active {
    ${styles.borderColor.success};
  }
`;

const size = {
  default: css`
    padding: 10px 14px;
  `,
  sm: css`
    padding: 0px 5px;
  `,
};

export const Input = styled.input<
  InputHTMLAttributes<HTMLInputElement> & {
    success?: boolean;
    danger?: boolean;
    s?: keyof typeof size;
  }
>`
  width: 100%;
  ${styles.border.md};
  box-sizing: border-box;
  ${styles.rounded.md};
  transition: all 0.3s;
  ${(props) => size[props.s || props.size || 'default']};

  outline: none;
  :hover,
  :focus,
  :active {
    ${styles.borderColor.primary};
  }

  ::placeholder {
    ${styles.color.textLight};
  }

  ${(props) => (props.success ? success : null)};
  ${(props) => (props.danger ? danger : null)};
`;
export const TextArea = styled.textarea<
  InputHTMLAttributes<HTMLTextAreaElement> & {
    success?: boolean;
    danger?: boolean;
    s?: keyof typeof size;
  }
>`
  width: 100%;
  ${styles.border.md};
  box-sizing: border-box;
  outline: none;
  ${styles.rounded.md};
  transition: all 0.3s;
  ${(props) => size[props.s || props.size || 'default']};

  :hover,
  :focus,
  :active {
    ${styles.borderColor.primary};
  }
  ${(props) => (props.success ? success : null)};
  ${(props) => (props.danger ? danger : null)};
`;
